import {createAction} from 'redux-actions';
import {actionTypes as system} from '../System';
import {handleActions} from '../../Utility/HandleActions';
import {$set, $get, $all} from 'plow-js';

//
// actionTypes
//
const TOGGLE_OPTIONS_MENU = 'DBM/UI/MENU/TOGGLE_OPTIONS_MENU';
const TOGGLE_OPTIONS_BUTTON = 'DBM/UI/MENU/TOGGLE_OPTIONS_BUTTON';
const TOGGLE_VALUEDATE_CALENDAR = 'DBM/UI/MENU/TOGGLE_VALUEDATE_CALENDAR';
const TOGGLE_OPTIONS_FORM = 'DBM/UI/MENU/TOGGLE_OPTIONS_FORM';

//
// Create actions
//
const toggleOptionsMenu = createAction(TOGGLE_OPTIONS_MENU);
const toggleOptionsButton = createAction(TOGGLE_OPTIONS_BUTTON);
const toggleValueDateCalendar = createAction(TOGGLE_VALUEDATE_CALENDAR);
const toggleOptionsForm = createAction(TOGGLE_OPTIONS_FORM);


export const actionTypes = {
    TOGGLE_OPTIONS_MENU,
    TOGGLE_OPTIONS_BUTTON,
    TOGGLE_VALUEDATE_CALENDAR,
    TOGGLE_OPTIONS_FORM
};

export const actions = {
    toggleOptionsMenu,
    toggleOptionsButton,
    toggleValueDateCalendar,
    toggleOptionsForm
};

//
// Export reducer
//
export const reducer = handleActions({
    [system.INIT]: () =>
        (state) => {
            return $all(
                $set('ui.optionsMenu.visibility', false),
                $set('ui.optionsButton.visibility', true),
                $set('ui.valueDateCalendar.visibility', false),
                $set('ui.optionsMenu.options.visibility', false),
                state
            );
        }
    ,

    [TOGGLE_OPTIONS_MENU]: () =>
        (state) => {

            // for switching portals in options menu we need to tell the which one should be open / closed
            // close valuedate calendar when closing options menu if it's visible
            if ($get('ui.optionsMenu.visibility', state) && $get('ui.valueDateCalendar.visibility', state)){

                return $all(
                    $set('ui.valueDateCalendar.visibility', false),
                    $set('ui.optionsMenu.visibility', !($get('ui.optionsMenu.visibility', state))),
                    state
                );
            }

            if ($get('ui.optionsMenu.visibility', state) && $get('ui.optionsMenu.options.visibility', state)){

                return $all(
                    $set('ui.optionsMenu.options.visibility', false),
                    $set('ui.optionsMenu.visibility', !($get('ui.optionsMenu.visibility', state))),
                    state
                );
            }

            return $set('ui.optionsMenu.visibility', !($get('ui.optionsMenu.visibility', state)), state);
        }
    ,

    [TOGGLE_OPTIONS_BUTTON]: () =>
        (state) => {
            return $set('ui.optionsButton.visibility', !($get('ui.optionsButton.visibility', state)), state);
        }
    ,

    [TOGGLE_VALUEDATE_CALENDAR]: () =>
        (state) => {
            return $set('ui.valueDateCalendar.visibility', !($get('ui.valueDateCalendar.visibility', state)), state);
        }
    ,

    [TOGGLE_OPTIONS_FORM]: () =>
        (state) => {
            if ($get('ui.valueDateCalendar.visibility', state)){
                return state;
            }
            return $set('ui.optionsMenu.options.visibility', !($get('ui.optionsMenu.options.visibility', state)), state);
        }
});

const isMenuOpen = $get('ui.optionsMenu.visibility');
const isButtonVisible = $get('ui.optionsButton.visibility');
const isValueDateVisible = $get('ui.valueDateCalendar.visibility');
const isOptionsVisible = $get('ui.optionsMenu.options.visibility');


export const selectors = {
    isMenuOpen,
    isButtonVisible,
    isValueDateVisible,
    isOptionsVisible
};